/**
 * @file Replacements for console.error, console.warn, console.log to
 * additionally send information to Rollbar
 */

function error(...args) {
  console.error(...args)
}

function log(...args) {
  console.log(...args)
}

function warn(...args) {
  console.warn(...args)
}

export default {
  error,
  log,
  warn,
}
